import { inject, Inject, Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpMainService } from '../http-main.service';
import {
  CodeIntroducerResponseModel,
  CodeUpdateRequestModel,
  ListModel,
  ReceiptRequestModel,
  ReceiptResponseModel,
} from '@itb-monorepo/models';
import {
  APP_TOKEN,
  AppsEnum,
  ReceiptEnum,
  StatusEnum,
} from '@itb-monorepo/enums';

@Injectable({
  providedIn: 'root',
})
export class ReceiptsService {
  baseUrl = '/finance/';
  public app = inject(APP_TOKEN);
  private _HttpMainService = inject(HttpMainService);

  receiptsList(
    params: any,
    user_id: string
  ): Observable<ListModel<ReceiptResponseModel>> {
    const url = `${this.baseUrl}v1/users/${user_id}/receipts`;

    let filters: string[] = [];
    if (params.type && params.type !== 'ALL') {
      filters.push(`type:eq("${params.type}")`);
    }
    if (params.gatewayCode) {
      filters.push(`gateway_code:eq("${params.gatewayCode}")`);
    }

    if (params.status && params.status !== 'ALL') {
      if (params.status === StatusEnum.FAILED) {
        filters.push(`status:in("FAILED","REJECTED")`);
      } else {
        filters.push(`status:eq("${params.status}")`);
      }
    }

    if (params.destination_user_id) {
      filters.push(`destination_user_id:neq("${params.destination_user_id}")`);
    }

    if (
      params.wallet &&
      this.app === AppsEnum.IB &&
      (!params.source || params.source === 'AllAccounts')
    ) {
      if (params.type === ReceiptEnum.DEPOSIT) {
        filters.push(`destination:eq("${params.wallet}")`);
      } else {
        filters.push(`source:eq("${params.wallet}")`);
      }
    }
    if (this.app === AppsEnum.TRADER) {
      if (
        params.destination &&
        params.destination !== 'AllAccounts' &&
        params.type !== ReceiptEnum.WITHDRAW
      ) {
        filters.push(`destination:eq("${params.destination}")`);
      }

      if (
        params.source &&
        params.source !== 'AllAccounts' &&
        params.type !== ReceiptEnum.DEPOSIT
      ) {
        filters.push(`source:eq("${params.source}")`);
      }
    }
    if (this.app !== AppsEnum.TRADER) {
      if (params.destination && params.destination !== 'AllAccounts') {
        filters.push(`destination:eq("${params.destination}")`);
      }
      if (params.source && params.source !== 'AllAccounts') {
        filters.push(`source:eq("${params.source}")`);
      }
    }
    if (params.from) {
      filters.push(`created_at:gte("${params.from}")`);
    }

    if (params.to) {
      filters.push(`created_at:lte("${params.to}")`);
    }

    if (params.minAmount !== undefined) {
      filters.push(`amount:gte("${params.minAmount}")`);
    }
    const filterString = filters.join(',');

    return this._HttpMainService.get(url, {
      skip: params.skip,
      take: params.take,
      filter: filterString,
      include: 'gateway,currency',
      sort: 'desc(created_at)',
    });
  }

  addReceipt(
    inputs: ReceiptRequestModel,
    user_Id?: string,
    context?: HttpContext
  ): Observable<ReceiptResponseModel> {
    const url = `${this.baseUrl}v1/users/${
      user_Id ? user_Id : 'current'
    }/receipts`;
    return this._HttpMainService.post(url, inputs, undefined, context);
  }

  getReceipt(receipt_id: string): Observable<ReceiptResponseModel> {
    const url = `${this.baseUrl}v1/receipts/${receipt_id}`;
    return this._HttpMainService.get(url);
  }

  deleteReceipt(receipt_id: string) {
    const url = `${this.baseUrl}v1/receipts/${receipt_id}`;
    return this._HttpMainService.delete(url);
  }
  retryReceipt(receipt_id: string): Observable<CodeIntroducerResponseModel> {
    return this._HttpMainService.put(
      `${this.baseUrl}v1/receipts/${receipt_id}/retry`);
  }
}
